import { render, staticRenderFns } from "./start.vue?vue&type=template&id=4c6b775e&scoped=true"
import script from "./start.vue?vue&type=script&lang=js"
export * from "./start.vue?vue&type=script&lang=js"
import style0 from "./start.vue?vue&type=style&index=0&id=4c6b775e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6b775e",
  null
  
)

export default component.exports